import ObjectFitImages from 'object-fit-images';

const images = document.querySelectorAll('.card__image');
ObjectFitImages(images);
